import React from 'react';
import NoPermission from 'icons/no-permission.svg';
import { SimplePlaceHolder } from 'components/SimplePlaceholder';
import Page from '../App/Page';
import styles from './NotPermittedRoute.scss';

export const NotPermittedRoute = () => (
  <Page className={styles.container} title="" showBreadcrumbs={false}>
    <SimplePlaceHolder
      title="Sorry."
      subTitle="You don't have <b>permission</b> to access this page."
      content="Please ask your administrator for permission."
      image={NoPermission}
      alt="no permission"
    />
  </Page>
);
